import { Card, CardMedia } from '@mui/material'
import React from 'react'

function TourCardserv({ imgs }) {
  return (
    <Card
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        overflow: "inherit",
        margin: "10px",
        borderRadius: '30px'

      }}>
      <CardMedia
        sx={{
          "&.MuiCardMedia-root:hover": {
            borderRadius: '30px',
            height: '300px',
            width: '300px',
            transform: "scale(1.1)",
            transition: ".5s",
          },
          borderRadius: '30px'
        }}
        component="img"
        height="350px"
        image={imgs}
        alt="green iguana"
      />
    </Card>
  )
}

export default TourCardserv